module.exports = __webpack_public_path__ + "static/media/react.b9eb528b.svg";